import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'

import Checkbox from 'lib/forms/checkbox-svg'

import filtersLogic from '~/scenes/search/filters-page/logic'

const translations = {
  'home,studio': I18n.t('react.search.filters.location.home_and_studio'),
  studio: I18n.t('react.search.filters.location.studio'),
  home: I18n.t('react.search.filters.location.home'),
  webcam: I18n.t('react.search.filters.location.webcam')
}

export default function LocationType () {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter, clearSuggestionResults } = useActions(filtersLogic)

  function toggleLocationType (locationType) {
    const currentValue = unsavedFilter.location_types
    updateUnsavedFilter({ location_types: currentValue === locationType ? '' : locationType })
  }

  const toggleLocation = locationType => {
    toggleLocationType(locationType.replace('_and_', ','))
    clearSuggestionResults()
  }

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.filters.location.title')}</div>
      <div className='checkbox-list'>
        {Object.keys(translations).map(locationType => (
          <Checkbox
            key={locationType}
            checked={unsavedFilter.location_types === locationType}
            onChange={() => {
              toggleLocation(locationType)
            }}
          >
            {translations[locationType]}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}
